export default "__VITE_ASSET__50327c95__"